import { render } from "./ScalesPage.vue?vue&type=template&id=7ac7260e"
import script from "./ScalesPage.vue?vue&type=script&lang=js"
export * from "./ScalesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../biotron-complaint-20260813/WebMidiVue-integrated/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__